export default {
      id: "reefer-failed-usage",
      viewBox: "0 0 107 110",
      url: __webpack_public_path__ + "img/icons.svg#reefer-failed",
      toString: function () {
        return this.url;
      }
    }